import { render, staticRenderFns } from "./L3FrameWithTitle.vue?vue&type=template&id=a5e491d6&scoped=true&"
import script from "./L3FrameWithTitle.vue?vue&type=script&lang=ts&"
export * from "./L3FrameWithTitle.vue?vue&type=script&lang=ts&"
import style0 from "./L3FrameWithTitle.vue?vue&type=style&index=0&id=a5e491d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e491d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VCard,VCardText,VChip})
